import { EMessageTypes, PaginatedQuestion, QuestionComment } from "./working-model";

export type ApproveType = PaginatedQuestion;

export type DeleteType = {
	id: number;
}

export type DeleteQuestionComment = {
	comment_id: number;
	module_id: number | null;
	question_id: number;
}

export type QuestionBan = {
	type: "question" | "question_comment";
	id: number;
	question_id: number;
}

export type AnsweredQuestion = {
	question_ids: number[];
	answered: boolean;
}

export type StatusUpdate = {
	id: string;
	message_type: EMessageTypes;
	presenter_status_update: number;
}

export type ChatMessage<T = PaginatedQuestion> = {
	type: string,
	chat_messages: T[],
}

export type ModeratorReply = {
	type: string,
	moderator_reply: boolean,
	data: QuestionComment
}

export type Message<T> = {
	type: string,
	chat_messages?: PaginatedQuestion[],
	moderator_reply?: boolean,
	data: T
};

export enum EModeratorSocketTypes {
	ChatUserBanned = 'chat_user_banned',
}

export type BannedChatUser = {
	bl_profile: number | null;
	bl_profile_non_reg: number | null;
}
